module.exports = __webpack_public_path__ + "static/media/0_2019_08_30.1b8548b0.jpg";